export default {"src":"/_next/static/media/play-space.26a6d911.svg","height":106,"width":116,"blurWidth":0,"blurHeight":0};